import {closeSpinner, showErrorMessage, showSuccessMessage, showToast,openSpinner} from "../ui/ui";
import {t} from "../i18n";
import {exportImageCollection} from "./output/outputGeneration";
import {exportPartsList} from "./output/componentListExport";
import {calculateVolumes} from "./calculators/buildingParameters/volumeCalculator";
import { TransactionManager } from "./TransactionManager";
import { beforeUnloadOperation } from "../ui/events/uiEvents";

const shopUrl = "https://shop.digicon.house/";


export function checkoutProject(callback = null, errorCallback = null) {
    let id = templateId;

    openSpinner("Bitte warten"); // please be patient in german
    let configData = { 'configuration_id': id };
    TransactionManager.undoStates = [];
    exportImageCollection(false, () => {
        exportPartsList(false).then(function () {
            fetch('/api/hornbach/complete-configuration', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(configData)
            })
                .then(response => response.json())
                .then(data => {
                    closeSpinner();
                    // Redirect to Hornbach
                    if (data.targetUrl) {
                        // Remove beforeunload listeners to prevent "Leave Site?" dialog
                        $(window).off('beforeunload');
                        window.removeEventListener("beforeunload",beforeUnloadOperation);
                        

                        window.location.href = data.targetUrl;
                    } else {
                        showErrorMessage(t("cart_error", {error: data.message}));
                        console.error('Error completing configuration:', data.message);
                        // Handle error
                    }
                })
                .catch(error => {
                    showErrorMessage(t("cart_error", {error: error?.message || error}));
                    console.error('Error:', error);
                    // Handle error
                    closeSpinner();
                });
        });
    }, () => { });


    //Bilder und Stückliste erstellen und hochladen
    // exportImageCollection();
    // exportPartsList(false).then(function() {
    //     $.ajax({
    //         url: 'configurator/checkout/' + id,
    //         method: 'post',
    //         headers: {
    //             'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    //         },
    //         async: false,
    //         data: {
    //             v: calculateVolumes()
    //         },
    //         success: function (data) {
    //             if (data.success) {
    //                 callback();
    //                 showSuccessMessage("Wir haben Ihre Bestellung erhalten");
    //                 // redirectToShop(data.url) //TODO: Aktivieren wenn Shopanbindung abgeschlossen // Activate when shop integration is completed

    //             } else {
    //                 errorCallback();
    //                 showErrorMessage("Fehler beim Hinzufügen des Produkts zum Warenkorb. \n" + data.error);
    //             }
    //         },
    //         fail: function (data) {
    //             errorCallback();
    //             showErrorMessage(data.error);
    //         }
    //     });
    // });

}

function redirectToShop(urlPart) {
    location.href = shopUrl + urlPart;
}
